/**
 * Registra o service worker e recarrega a página quando um build novo assume o controle.
 *
 * O `sw.js` gerado pelo vite-plugin-pwa já faz `skipWaiting()` + `clientsClaim()`, então a
 * versão nova ativa sozinha — mas a aba que está aberta continua com os arquivos do build
 * anterior até uma navegação. É esse recarregamento que falta, e é o que dispensa o Ctrl+F5.
 */

/** Janela em que um recarregamento é seguro: o usuário acabou de chegar e não digitou nada. */
const SAFE_RELOAD_MS = 10_000;
const HOUR = 60 * 60 * 1000;

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return;

  // Sem controller, esta página não veio do cache do SW: a primeira instalação não precisa recarregar.
  const hadController = Boolean(navigator.serviceWorker.controller);
  const loadedAt = Date.now();
  let reloading = false;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController || reloading) return;
    // Passada a janela segura, o usuário pode estar com o formulário preenchido;
    // a versão nova já está ativa e entra na próxima navegação.
    if (Date.now() - loadedAt > SAFE_RELOAD_MS) return;
    reloading = true;
    window.location.reload();
  });

  navigator.serviceWorker.register('/sw.js', { scope: '/' }).then((registration) => {
    const check = () => { void registration.update().catch(() => {}); };
    check();
    // Aba que volta do segundo plano é o momento mais comum de pegar um deploy novo.
    document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); });
    setInterval(check, HOUR);
  }).catch(() => {
    // Sem service worker o app funciona igual, só perde o modo offline.
  });
}
